"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Teller_1 = require("../../../../../DriveScout/Billing/Teller");
var saveToDisk_1 = require("../../../../common/helpers/saveToDisk");
var ViewOrderController = /** @class */ (function () {
    function ViewOrderController(OrdersModel, FlashService, OrderDetailsService, PoliciesModel, $q, UserService, UsersModel, order) {
        this.loading = false;
        this.submitting = false;
        this.OrdersModel = OrdersModel;
        this.FlashService = FlashService;
        this.OrderDetailsService = OrderDetailsService;
        this.PoliciesModel = PoliciesModel;
        this.$q = $q;
        this.UsersModel = UsersModel;
        this.busy = false;
        this.page_by = 20;
        this.order = order;
        this.billingConfig = {
            gateway: '',
            gateway_config: {},
            policyMeta: {}
        };
        this.clearPaymentForm = false;
        this.currentUser = UserService.getCurrentUser();
        this.patchOrder = this.patchOrder.bind(this);
        this.submitPayment = this.submitPayment.bind(this);
        this.voidPayment = this.voidPayment.bind(this);
        this.voidOrder = this.voidOrder.bind(this);
        this.sendOrder = this.sendOrder.bind(this);
        this.printOrder = this.printOrder.bind(this);
        this.refundOrder = this.refundOrder.bind(this);
        this.inDollars = Teller_1.inDollars.bind(this);
    }
    ViewOrderController.prototype.patchOrder = function (updatedOrder) {
        this.order = updatedOrder;
    };
    ViewOrderController.prototype.showOrderDetails = function (order) {
        var _this = this;
        this.$q.all([this.PoliciesModel.getByID('billing'), this.OrdersModel.getDetails({ id: order.id })]).then(function (responses) {
            _this.order = _this.OrderDetailsService.setupOrderDetails(responses[1], order);
            _this.billingConfig = _this.OrderDetailsService.configureBilling(responses[0]);
            if (_this.billingConfig.gateway === 'paypal') {
                // this.configurePaypal(order, this.billingConfig);
            }
            _this.clearPaymentForm = false;
            _this.loading = false;
        });
    };
    ViewOrderController.prototype.submitPayment = function (data) {
        var _this = this;
        var payment = data.payment;
        this.submitting = true;
        this.OrderDetailsService.setPayment(payment);
        this.OrderDetailsService.submitPayment().then(function (response) {
            // console.log('details service response', response)
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.order.payments.push(response.payment);
            _this.submitting = false;
            _this.order.paid = response.order.paid;
            _this.order.notes = response.order.notes;
            _this.patchOrder(_this.order);
            _this.clearPaymentForm = true;
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    ViewOrderController.prototype.voidPayment = function (data) {
        var _this = this;
        var payment_id = data.payment_id, index = data.index;
        this.submitting = true;
        this.UsersModel.voidPayment(this.order.student.id, payment_id).then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.order.payments.splice(index, 1, response.payment);
            _this.patchOrder(_this.order);
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    ViewOrderController.prototype.voidOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.voidOrder(data.order_id).then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.order.status = 'VOID';
            _this.patchOrder(_this.order);
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    ViewOrderController.prototype.sendOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.sendOrder(data.order_id, { 'recipient': data.receipt_email }).then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    ViewOrderController.prototype.printOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.printOrder(data.order_id).then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            (0, saveToDisk_1.saveToDisk)(response.url);
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    ViewOrderController.prototype.refundOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.refundOrder(data.order_id).then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.order = response.order;
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    return ViewOrderController;
}());
ViewOrderController.$inject = ['OrdersModel', 'FlashService', 'OrderDetailsService', 'PoliciesModel', '$q', 'UserService', 'UsersModel', 'order'];
exports.default = ViewOrderController;
